import { render } from "./FeedbackCard.vue?vue&type=template&id=82ba8288&scoped=true"
import script from "./FeedbackCard.vue?vue&type=script&lang=js"
export * from "./FeedbackCard.vue?vue&type=script&lang=js"

import "./FeedbackCard.vue?vue&type=style&index=0&id=82ba8288&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82ba8288"]])

export default __exports__